import { getOrderPlatform } from './orderPlatform';

/**
 * Extracts order ID from order details pathname and determines the platform.
 *
 * @param pathname - The pathname to extract order ID from (e.g., '/account/order-details/12345')
 * @returns The platform ('sfcc' or 'commercetools'), defaults to 'commercetools' if no order ID found
 */
export const getOrderPlatformFromPath = (pathname: string | null | undefined): 'commercetools' | 'sfcc' => {
    if (!pathname?.includes('/account/order-details/')) {
        return 'commercetools';
    }

    const orderIdRegex = /\/account\/order-details\/([^/?#]+)/;
    const orderIdMatch = orderIdRegex.exec(pathname);
    const orderId = orderIdMatch?.[1];

    return orderId ? getOrderPlatform(orderId) : 'commercetools';
};
